import { createFileRoute } from "@tanstack/react-router";
import { SprzKasjerDataReport } from "@/features/reports/sprz-kasjer-data-report";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/sprz_kasjer_data")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty-pesel.sprz-kasjer-data",
			location.pathname,
		);
	},
	component: SprzKasjerDataReport,
});
